const sectionItemsSlideB1Css = `
[data-type='section-items-slide-b1'] .wrapper-container[data-top-padding='true'] {
  padding-top: 40px;
}

[data-type='section-items-slide-b1'] .wrapper-container[data-bottom-padding='true'] {
  padding-bottom: 40px;
}

[data-type='section-items-slide-b1'] .header-section:not(:empty) {
  margin-bottom: 16px;
}

[data-type='section-items-slide-b1'] .header-section h1,
[data-type='section-items-slide-b1'] .header-section h2,
[data-type='section-items-slide-b1'] .header-section h3 {
  font-size: 24px;
  line-height: normal;
  margin: 0 0 16px 0 !important;
}

[data-type='section-items-slide-b1'] .wrap-item {
  position: relative;
  overflow: hidden;
  aspect-ratio: 243 / 394;
  display: flex;
  align-items: flex-end;
  padding: 10px;
  border-radius: 12px;
}

[data-type='section-items-slide-b1'] .wrap-item [data-attribute='image'] {
  position: absolute;
  width: 100%;
  height: 100%;
  inset: 0;
  object-fit: cover;
  z-index: 1;
}

[data-type='section-items-slide-b1'] .wrap-item .overlay-item {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #000;
  opacity: 0.5;
  z-index: 2;
}

[data-type='section-items-slide-b1'] .wrap-item .wrap-text {
  position: relative;
  z-index: 10;
  color: #fff;
}

[data-type='section-items-slide-b1'] .wrap-item .wrap-text h1,
[data-type='section-items-slide-b1'] .wrap-item .wrap-text h2,
[data-type='section-items-slide-b1'] .wrap-item .wrap-text h3,
[data-type='section-items-slide-b1'] .wrap-item .wrap-text h4 {
  font-size: 20px;
  line-height: normal;
  margin: 0 0 10px 0 !important;
}

[data-type='section-items-slide-b1'] .btn-cta {
  display: none;
  padding: 14px 32px;
  border-radius: 12px;
  margin: 0 auto !important;
  margin-top: 20px !important;
  text-align: center;
  text-decoration: none;
  color: #fff;
  max-width: 320px;
}

[data-type='section-items-slide-b1'] .btn-cta[data-show-button='true'] {
  display: block;
}

[data-type='section-items-slide-b1'] .swiper-pagination-custom {
  position: relative;
  margin-top: 15px;
}

[data-type='section-items-slide-b1'] .swiper-pagination-custom .swiper-pagination-bullet-active {
  background-color: #000;
}

@container (max-width: 768px) {
  [data-type='section-items-slide-b1'] .wrapper-container[data-top-padding='true'] {
    padding-top: 16px;
  }

  [data-type='section-items-slide-b1'] .wrapper-container[data-bottom-padding='true'] {
    padding-bottom: 16px;
  }

  [data-type='section-items-slide-b1'] .header-section h1,
  [data-type='section-items-slide-b1'] .header-section h2,
  [data-type='section-items-slide-b1'] .header-section h3 {
    font-size: 20px;
    line-height: 24px;
  }

  [data-type='section-items-slide-b1'] .wrap-item .wrap-text h1,
  [data-type='section-items-slide-b1'] .wrap-item .wrap-text h2,
  [data-type='section-items-slide-b1'] .wrap-item .wrap-text h3,
  [data-type='section-items-slide-b1'] .wrap-item .wrap-text h4 {
    font-size: 20px;
    line-height: 24px;
  }
}
`;
export default sectionItemsSlideB1Css;
